import { marked } from 'marked'
import hljs from 'highlight.js'
import 'highlight.js/styles/github.css'
import { sanitizeHtml } from './sanitizeHtml'

let configured = false

/** 将 **加粗** 转为 <strong>，兼容中文标点结尾（CommonMark 常无法解析 **标题：**） */
function boldifySegment(text) {
  return text.replace(/\*\*([^*\n]+?)\*\*/g, '<strong>$1</strong>')
}

export function preprocessBoldMarkers(content) {
  if (!content) return ''
  const parts = []
  const fenceRe = /(```[\s\S]*?```|`[^`\n]+`)/g
  let last = 0
  let match
  while ((match = fenceRe.exec(content)) !== null) {
    parts.push(boldifySegment(content.slice(last, match.index)))
    parts.push(match[0])
    last = match.index + match[0].length
  }
  parts.push(boldifySegment(content.slice(last)))
  return parts.join('')
}

export function configureMarked() {
  if (configured) return
  marked.setOptions({
    highlight(code, lang) {
      if (lang && hljs.getLanguage(lang)) {
        try {
          return hljs.highlight(code, { language: lang }).value
        } catch (e) {
          console.error(e)
        }
      }
      return hljs.highlightAuto(code).value
    },
    breaks: true,
    gfm: true
  })
  configured = true
}

export function renderMarkdown(content) {
  configureMarked()
  if (!content) return ''
  return sanitizeHtml(marked.parse(preprocessBoldMarkers(content)))
}

/** 测评说明常用写法：行首 `--` 转为列表项 */
export function preprocessExamMarkdown(content) {
  if (!content) return ''
  return String(content)
    .replace(/\r\n/g, '\n')
    .replace(/^--\s+/gm, '- ')
}

export function renderExamMarkdown(content) {
  return renderMarkdown(preprocessExamMarkdown(content))
}
